<md-content-box class="lesson-block" [type]="isProjectProgressInvalid() ? 'error' : 'default'">
	<md-icon icon="untitled-ui/files/file-02"></md-icon>
	<div class="lesson-block__body">
		<div class="lesson-block__header">
			<div class="lesson-block__title">
				<md-header size="xs">Project</md-header>
				<span md-tooltip="Required grade" class="required">*</span>
			</div>

			@if (loaded()) {
				<div class="lesson-block__progress">
					<md-progress-bar [progress]="progressPercent()" [height]="16"> </md-progress-bar>
					@if (progressLabel(); as progressLabel) {
						<md-tag type="tertiary">{{ progressLabel }}</md-tag>
					}
				</div>
			}
			<!-- Not gated on isReadOnly: the rubric explains the grade, so learners (and anyone on a locked
			     semester) may read it. The dialog is display-only. -->
			@if (rubricTabs().length > 0) {
				<button md-button class="view-rubrics-btn" (click)="openRubricDialog()">View Rubric</button>
			}
		</div>

		@if (loading()) {
			<lb-loader></lb-loader>
		} @else {
			<div class="lesson-block__content">
				@if (!isReadOnly()) {
					<md-drop-down
						placeholder="Select project progress milestone"
						[dense]="true"
						[disabled]="fieldsDisabled()"
						[options]="milestoneOptions()"
						[value]="selectedProjectMilestoneID()"
						(change)="onMilestoneChange($event)"
					></md-drop-down>

					<lb-audio-transcribe-input [languageID]="state.lesson()?.languageID ?? null" [disabled]="fieldsDisabled()">
						<label label for="project-progress-notes">Progress Notes</label>
						<textarea
							id="project-progress-notes"
							md-form-input
							rows="4"
							placeholder="Add notes on project progress (optional)"
							[disabled]="fieldsDisabled()"
							[value]="notes()"
							(input)="onNotesChange($any($event.target).value)"
						></textarea>
					</lb-audio-transcribe-input>
				} @else {
					@if (selectedMilestoneLabel(); as milestoneLabel) {
						<div class="milestone-display">
							<md-tag type="default">{{ milestoneLabel }}</md-tag>
						</div>
					}

					@if (notes()) {
						<md-content-box type="tertiary" class="notes">
							<div class="notes__header">
								<md-icon icon="untitled-ui/alerts/notification-text"></md-icon>
								<span>Project Notes</span>
							</div>
							<lb-rich-text-view [content]="notes()" />
						</md-content-box>
					}
				}
			</div>
		}
	</div>
</md-content-box>
